import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from './config';
import Nav from './Nav';
import { Explain } from './Explain';
import { TrustBar, LensChips, fmtScore, scoreColor, scoreScale } from './trustShared';
import './css/trust.css';

function TrustAtlas() {
  const [lenses, setLenses] = useState([]);
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDomains = async () => {
      try {
        const response = await apiFetch('/api/trust/domains');
        if (!response.ok) throw new Error('Failed to load trust domains');
        const data = await response.json();
        setLenses(data.lenses);
        setDomains(data.domains);
        setError(null);
      } catch (err) {
        setError('Failed to load trust domains');
        console.error('Error fetching trust domains:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchDomains();
  }, []);

  return (
    <div className="trust-page">
      <Nav />
      <div style={{ maxWidth: '980px', margin: '0 auto', padding: '0 20px 40px' }}>
        <h1 style={{ marginTop: 0, marginBottom: '6px' }}><Explain concept="domain">Trust Atlas</Explain></h1>

        {error && <div style={{ color: 'var(--wv-neg)', marginBottom: '10px' }}>{error}</div>}
        {loading ? (
          <p>Loading...</p>
        ) : domains.length === 0 ? (
          <p className="trust-muted">No domains yet — tag some objects to populate the atlas.</p>
        ) : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginTop: '18px' }}>
            {domains.map((d) => (
              <Link key={d.tag_id} to={`/trust/${d.tag_id}`} className="trust-card">
                <div
                  style={{
                    height: '4px',
                    borderRadius: '2px',
                    backgroundColor: scoreScale(d.combined),
                    marginBottom: '10px',
                  }}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '8px' }}>
                  <h2 style={{ margin: 0, fontSize: '17px', overflowWrap: 'anywhere' }}>{d.name}</h2>
                  <Explain concept="combined-score">
                    <strong style={{ color: scoreColor(d.combined), fontSize: '15px', flexShrink: 0 }}>
                      {fmtScore(d.combined)}
                    </strong>
                  </Explain>
                </div>
                {d.parent_name && (
                  <div className="trust-muted" style={{ fontSize: '12px', marginTop: '2px' }}>
                    <Explain concept="domain">⊂ {d.parent_name}</Explain>
                  </div>
                )}
                <div style={{ margin: '10px 0' }}>
                  <TrustBar score={d.combined} width={248} />
                </div>
                <LensChips lenses={lenses} scores={d.lens_scores} size="small" />
                <div className="trust-muted" style={{ fontSize: '12px', marginTop: '10px' }}>
                  {d.object_count} object{d.object_count !== 1 ? 's' : ''} · {d.edge_count} relation
                  {d.edge_count !== 1 ? 's' : ''}
                  {d.conflict_count > 0 && (
                    <Explain concept="contested">
                      <span style={{ color: 'var(--wv-warn)', marginLeft: '8px' }}>
                        ⚡ {d.conflict_count} contested
                      </span>
                    </Explain>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default TrustAtlas;
